import React from "react";
import CsplLabel from "../../../CsplControls/CsplLabel/CsplLabel";
import styles from "../Preview.module.css";
import { OptionsEnum } from "../../../../Enumeration/OptionsEnum";
import { convertDateToString } from "../../../../Utils/DateUtils";
import { Accordion } from "react-bootstrap";
import "../../../CsplControls/CsplAccordion/CsplAccordion.css";

function PersonalInfoView(props) {
  return (
    <>
      <Accordion className="parentaccordion_style" defaultActiveKey="0">
        {/* Personal Info */}
        <div>
          <Accordion.Item eventKey="0" className="mb-3">
            <Accordion.Header>
              <span className="w-100">
                <CsplLabel label={"title.KeyPersonalInfo"}></CsplLabel>
              </span>
            </Accordion.Header>

            <Accordion.Body>
              <div className="dotted_line p-0">
                {/*Key Personal Info */}

                <Accordion
                  className="childaccordion_style"
                  defaultActiveKey="1"
                >
                  <Accordion.Item eventKey="1" className="m-0 p-0">
                    {props &&
                      props.data &&
                      props.data.personalInfoDTO &&
                      props.data.personalInfoDTO.keyPersonalInfoDTO && (
                        <div className={styles.table_content}>
                          <Accordion.Header className="mb-0">
                            <span className={styles.header}>
                              <CsplLabel
                                label={"title.KeyPersonalInfo"}
                              ></CsplLabel>
                            </span>
                          </Accordion.Header>

                          <Accordion.Body className={styles.accordion_table}>
                            <table className="table table-striped table-bordered border-white table-responsive">
                              <tbody className={styles.table_alternate_color}>
                                <tr>
                                  <th className={styles.table_header}>
                                    <CsplLabel
                                      label={"keyPersonalInfo.prefix"}
                                    ></CsplLabel>
                                  </th>
                                  <td>
                                    {
                                      props.data.personalInfoDTO
                                        .keyPersonalInfoDTO.title.shortName
                                    }
                                  </td>
                                </tr>
                                <tr>
                                  <th className={styles.table_header}>
                                    <CsplLabel
                                      label={"keyPersonalInfo.firstName"}
                                    ></CsplLabel>
                                  </th>
                                  <td>
                                    {
                                      props.data.personalInfoDTO
                                        .keyPersonalInfoDTO.firstName
                                    }
                                  </td>
                                </tr>

                                {props.data.personalInfoDTO
                                  .keyPersonalInfoDTO &&
                                  props.data.personalInfoDTO.keyPersonalInfoDTO
                                    .middleName && (
                                    <tr>
                                      <th className={styles.table_header}>
                                        <CsplLabel
                                          label={"keyPersonalInfo.middleName"}
                                        ></CsplLabel>
                                      </th>
                                      <td>
                                        {
                                          props.data.personalInfoDTO
                                            .keyPersonalInfoDTO.middleName
                                        }
                                      </td>
                                    </tr>
                                  )}

                                {props.data.personalInfoDTO
                                  .keyPersonalInfoDTO &&
                                  props.data.personalInfoDTO.keyPersonalInfoDTO
                                    .lastName && (
                                    <tr>
                                      <th className={styles.table_header}>
                                        <CsplLabel
                                          label={"keyPersonalInfo.lastName"}
                                        ></CsplLabel>
                                      </th>
                                      <td>
                                        {
                                          props.data.personalInfoDTO
                                            .keyPersonalInfoDTO.lastName
                                        }
                                      </td>
                                    </tr>
                                  )}
                                <tr>
                                  <th className={styles.table_header}>
                                    <CsplLabel
                                      label={"keyPersonalInfo.motherName"}
                                    ></CsplLabel>
                                  </th>
                                  <td>
                                    {
                                      props.data.personalInfoDTO
                                        .keyPersonalInfoDTO.motherName
                                    }
                                  </td>
                                </tr>
                                <tr>
                                  <th className={styles.table_header}>
                                    <CsplLabel
                                      label={"keyPersonalInfo.dateOfBirth"}
                                    ></CsplLabel>
                                  </th>
                                  <td>
                                    {convertDateToString(
                                      props.data.personalInfoDTO
                                        .keyPersonalInfoDTO.dateOfBirth,
                                      "DD-MM-YYYY",
                                    )}
                                  </td>
                                </tr>

                                <tr>
                                  <th className={styles.table_header}>
                                    <CsplLabel
                                      label={"keyPersonalInfo.AddressLine1"}
                                    ></CsplLabel>
                                  </th>
                                  <td>
                                    {
                                      props.data.personalInfoDTO
                                        .keyPersonalInfoDTO
                                        .permanentAddressLine1
                                    }
                                  </td>
                                </tr>
                                {props.data.personalInfoDTO
                                  .keyPersonalInfoDTO &&
                                  props.data.personalInfoDTO.keyPersonalInfoDTO
                                    .permanentAddressLine2 && (
                                    <tr>
                                      <th className={styles.table_header}>
                                        <CsplLabel
                                          label={"keyPersonalInfo.AddressLine2"}
                                        ></CsplLabel>
                                      </th>
                                      <td>
                                        {
                                          props.data.personalInfoDTO
                                            .keyPersonalInfoDTO
                                            .permanentAddressLine2
                                        }
                                      </td>
                                    </tr>
                                  )}
                                {props.data.personalInfoDTO
                                  .keyPersonalInfoDTO &&
                                  props.data.personalInfoDTO.keyPersonalInfoDTO
                                    .permanentAddressLine3 && (
                                    <tr>
                                      <th className={styles.table_header}>
                                        <CsplLabel
                                          label={"keyPersonalInfo.AddressLine3"}
                                        ></CsplLabel>
                                      </th>
                                      <td>
                                        {
                                          props.data.personalInfoDTO
                                            .keyPersonalInfoDTO
                                            .permanentAddressLine3
                                        }
                                      </td>
                                    </tr>
                                  )}
                                <tr>
                                  <th className={styles.table_header}>
                                    <CsplLabel
                                      label={"keyPersonalInfo.City"}
                                    ></CsplLabel>
                                  </th>
                                  <td>
                                    {
                                      props.data.personalInfoDTO
                                        .keyPersonalInfoDTO.permanentCity
                                    }
                                  </td>
                                </tr>
                                <tr>
                                  <th className={styles.table_header}>
                                    <CsplLabel
                                      label={"keyPersonalInfo.Country"}
                                    ></CsplLabel>
                                  </th>
                                  <td>
                                    {
                                      props.data.personalInfoDTO
                                        .keyPersonalInfoDTO.permanentCountry
                                        .name
                                    }
                                  </td>
                                </tr>
                                <tr>
                                  <th className={styles.table_header}>
                                    <CsplLabel
                                      label={"keyPersonalInfo.State"}
                                    ></CsplLabel>
                                  </th>
                                  <td>
                                    {
                                      props.data.personalInfoDTO
                                        .keyPersonalInfoDTO.permanentState.name
                                    }
                                  </td>
                                </tr>
                                <tr>
                                  <th className={styles.table_header}>
                                    <CsplLabel
                                      label={"keyPersonalInfo.PinCode"}
                                    ></CsplLabel>
                                  </th>
                                  <td>
                                    {
                                      props.data.personalInfoDTO
                                        .keyPersonalInfoDTO.permanentPinCode
                                    }
                                  </td>
                                </tr>
                                {/* */}
                                <tr>
                                  <th className={styles.table_header}>
                                    <CsplLabel
                                      label={
                                        "keyPersonalInfo.permanentAddressSameAsCkycAadhar"
                                      }
                                    ></CsplLabel>
                                  </th>
                                  <td>
                                    {
                                      props.data.personalInfoDTO
                                        .keyPersonalInfoDTO
                                        .isPermanentAddressSameAsCKYCAadhaar
                                    }
                                  </td>
                                </tr>
                                {props.data.personalInfoDTO.keyPersonalInfoDTO
                                  .isPermanentAddressSameAsCKYCAadhaar ==
                                  OptionsEnum.No && (
                                  <tr>
                                    <th className={styles.table_header}>
                                      <CsplLabel
                                        label={
                                          "keyPersonalInfo.addressProofType"
                                        }
                                      ></CsplLabel>
                                    </th>
                                    <td>
                                      {
                                        props.data.personalInfoDTO
                                          .keyPersonalInfoDTO.addressProofType
                                          .name
                                      }
                                    </td>
                                  </tr>
                                )}
                                <tr>
                                  <th className={styles.table_header}>
                                    <CsplLabel
                                      label={"keyPersonalInfo.AddressLine1"}
                                    ></CsplLabel>
                                  </th>
                                  <td>
                                    {
                                      props.data.personalInfoDTO
                                        .keyPersonalInfoDTO
                                        .modifiedPermanentAddressLine1
                                    }
                                  </td>
                                </tr>
                                <tr>
                                  <th className={styles.table_header}>
                                    <CsplLabel
                                      label={"keyPersonalInfo.AddressLine2"}
                                    ></CsplLabel>
                                  </th>
                                  <td>
                                    {
                                      props.data.personalInfoDTO
                                        .keyPersonalInfoDTO
                                        .modifiedPermanentAddressLine2
                                    }
                                  </td>
                                </tr>
                                <tr>
                                  <th className={styles.table_header}>
                                    <CsplLabel
                                      label={"keyPersonalInfo.AddressLine3"}
                                    ></CsplLabel>
                                  </th>
                                  <td>
                                    {
                                      props.data.personalInfoDTO
                                        .keyPersonalInfoDTO
                                        .modifiedPermanentAddressLine3
                                    }
                                  </td>
                                </tr>
                                <tr>
                                  <th className={styles.table_header}>
                                    <CsplLabel
                                      label={"keyPersonalInfo.City"}
                                    ></CsplLabel>
                                  </th>
                                  <td>
                                    {
                                      props.data.personalInfoDTO
                                        .keyPersonalInfoDTO
                                        .modifiedPermanentCity
                                    }
                                  </td>
                                </tr>
                                <tr>
                                  <th className={styles.table_header}>
                                    <CsplLabel
                                      label={"keyPersonalInfo.Country"}
                                    ></CsplLabel>
                                  </th>
                                  <td>
                                    {
                                      props.data.personalInfoDTO
                                        .keyPersonalInfoDTO
                                        .modifiedPermanentCountry.name
                                    }
                                  </td>
                                </tr>
                                <tr>
                                  <th className={styles.table_header}>
                                    <CsplLabel
                                      label={"keyPersonalInfo.State"}
                                    ></CsplLabel>
                                  </th>
                                  <td>
                                    {
                                      props.data.personalInfoDTO
                                        .keyPersonalInfoDTO
                                        .modifiedPermanentState.name
                                    }
                                  </td>
                                </tr>
                                <tr>
                                  <th className={styles.table_header}>
                                    <CsplLabel
                                      label={"keyPersonalInfo.PinCode"}
                                    ></CsplLabel>
                                  </th>
                                  <td>
                                    {
                                      props.data.personalInfoDTO
                                        .keyPersonalInfoDTO
                                        .modifiedPermanentPinCode
                                    }
                                  </td>
                                </tr>
                                {/*  */}
                                <tr>
                                  <th className={styles.table_header}>
                                    <CsplLabel
                                      label={
                                        "keyPersonalInfo.residentialAddressSameAsPermanentAddress"
                                      }
                                    ></CsplLabel>
                                  </th>
                                  <td>
                                    {
                                      props.data.personalInfoDTO
                                        .keyPersonalInfoDTO
                                        .residentialAddressSameAsPermanentAddress
                                    }
                                  </td>
                                </tr>
                                {props.data.personalInfoDTO
                                  .keyPersonalInfoDTO &&
                                  props.data.personalInfoDTO.keyPersonalInfoDTO
                                    .residentialAddressLine1 && (
                                    <tr>
                                      <th className={styles.table_header}>
                                        <CsplLabel
                                          label={"keyPersonalInfo.AddressLine1"}
                                        ></CsplLabel>
                                      </th>
                                      <td>
                                        {
                                          props.data.personalInfoDTO
                                            .keyPersonalInfoDTO
                                            .residentialAddressLine1
                                        }
                                      </td>
                                    </tr>
                                  )}
                                {props.data.personalInfoDTO
                                  .keyPersonalInfoDTO &&
                                  props.data.personalInfoDTO.keyPersonalInfoDTO
                                    .residentialAddressLine2 && (
                                    <tr>
                                      <th className={styles.table_header}>
                                        <CsplLabel
                                          label={"keyPersonalInfo.AddressLine2"}
                                        ></CsplLabel>
                                      </th>
                                      <td>
                                        {
                                          props.data.personalInfoDTO
                                            .keyPersonalInfoDTO
                                            .residentialAddressLine2
                                        }
                                      </td>
                                    </tr>
                                  )}
                                {props.data.personalInfoDTO
                                  .keyPersonalInfoDTO &&
                                  props.data.personalInfoDTO.keyPersonalInfoDTO
                                    .residentialAddressLine3 && (
                                    <tr>
                                      <th className={styles.table_header}>
                                        <CsplLabel
                                          label={"keyPersonalInfo.AddressLine3"}
                                        ></CsplLabel>
                                      </th>
                                      <td>
                                        {
                                          props.data.personalInfoDTO
                                            .keyPersonalInfoDTO
                                            .residentialAddressLine3
                                        }
                                      </td>
                                    </tr>
                                  )}
                                {props.data.personalInfoDTO
                                  .keyPersonalInfoDTO &&
                                  props.data.personalInfoDTO.keyPersonalInfoDTO
                                    .residentialCity && (
                                    <tr>
                                      <th className={styles.table_header}>
                                        <CsplLabel
                                          label={"keyPersonalInfo.City"}
                                        ></CsplLabel>
                                      </th>
                                      <td>
                                        {
                                          props.data.personalInfoDTO
                                            .keyPersonalInfoDTO.residentialCity
                                        }
                                      </td>
                                    </tr>
                                  )}

                                {props.data.personalInfoDTO
                                  .keyPersonalInfoDTO &&
                                  props.data.personalInfoDTO.keyPersonalInfoDTO
                                    .residentialCountry && (
                                    <tr>
                                      <th className={styles.table_header}>
                                        <CsplLabel
                                          label={"keyPersonalInfo.Country"}
                                        ></CsplLabel>
                                      </th>
                                      <td>
                                        {
                                          props.data.personalInfoDTO
                                            .keyPersonalInfoDTO
                                            .residentialCountry.name
                                        }
                                      </td>
                                    </tr>
                                  )}

                                {props.data.personalInfoDTO
                                  .keyPersonalInfoDTO &&
                                  props.data.personalInfoDTO.keyPersonalInfoDTO
                                    .residentialState && (
                                    <tr>
                                      <th className={styles.table_header}>
                                        <CsplLabel
                                          label={"keyPersonalInfo.State"}
                                        ></CsplLabel>
                                      </th>
                                      <td>
                                        {
                                          props.data.personalInfoDTO
                                            .keyPersonalInfoDTO.residentialState
                                            .name
                                        }
                                      </td>
                                    </tr>
                                  )}
                                {props.data.personalInfoDTO
                                  .keyPersonalInfoDTO &&
                                  props.data.personalInfoDTO.keyPersonalInfoDTO
                                    .residentialPinCode && (
                                    <tr>
                                      <th className={styles.table_header}>
                                        <CsplLabel
                                          label={"keyPersonalInfo.PinCode"}
                                        ></CsplLabel>
                                      </th>
                                      <td>
                                        {
                                          props.data.personalInfoDTO
                                            .keyPersonalInfoDTO
                                            .residentialPinCode
                                        }
                                      </td>
                                    </tr>
                                  )}
                                <tr>
                                  <th className={styles.table_header}>
                                    <CsplLabel
                                      label={"keyPersonalInfo.panNo"}
                                    ></CsplLabel>
                                  </th>
                                  <td>
                                    {
                                      props.data.personalInfoDTO
                                        .keyPersonalInfoDTO.panNo
                                    }
                                  </td>
                                </tr>
                                <tr>
                                  <th className={styles.table_header}>
                                    <CsplLabel
                                      label={"keyPersonalInfo.gender"}
                                    ></CsplLabel>
                                  </th>
                                  <td>
                                    {
                                      props.data.personalInfoDTO
                                        .keyPersonalInfoDTO.gender.name
                                    }
                                  </td>
                                </tr>
                                {props.data.personalInfoDTO
                                  .keyPersonalInfoDTO &&
                                  props.data.personalInfoDTO.keyPersonalInfoDTO
                                    .ckycNo && (
                                    <tr>
                                      <th className={styles.table_header}>
                                        <CsplLabel
                                          label={"keyPersonalInfo.ckycNo"}
                                        ></CsplLabel>
                                      </th>
                                      <td>
                                        {
                                          props.data.personalInfoDTO
                                            .keyPersonalInfoDTO.ckycNo
                                        }
                                      </td>
                                    </tr>
                                  )}
                                {/* {props.data.personalInfoDTO
                                  .keyPersonalInfoDTO &&
                                  props.data.personalInfoDTO.keyPersonalInfoDTO
                                    .isDifferentlyAbled && ( */}
                                <tr>
                                  <th className={styles.table_header}>
                                    <CsplLabel
                                      label={
                                        "keyPersonalInfo.isDifferentlyAbled"
                                      }
                                    ></CsplLabel>
                                  </th>
                                  <td>
                                    {props.data.personalInfoDTO
                                      .keyPersonalInfoDTO.isDifferentlyAbled ??
                                      "No"}
                                  </td>
                                </tr>
                                {/* )} */}

                                {props.data?.personalInfoDTO?.keyPersonalInfoDTO
                                  ?.isDifferentlyAbled === "Yes"
                                  ? [
                                      <tr key="type">
                                        <th className={styles.table_header}>
                                          <CsplLabel label="keyPersonalInfo.impairmentType" />
                                        </th>
                                        <td>
                                          {props.data?.personalInfoDTO
                                            ?.keyPersonalInfoDTO
                                            ?.impairmentTypeTagValue
                                            ?.name ?? ""}
                                        </td>
                                      </tr>,

                                      <tr key="percentage">
                                        <th className={styles.table_header}>
                                          <CsplLabel label="keyPersonalInfo.impairmentPercentage" />
                                        </th>
                                        <td>
                                          {props.data?.personalInfoDTO
                                            ?.keyPersonalInfoDTO
                                            ?.impairmentPercentage ?? ""}
                                        </td>
                                      </tr>,

                                      <tr key="udid">
                                        <th className={styles.table_header}>
                                          <CsplLabel label="keyPersonalInfo.udidNo" />
                                        </th>
                                        <td>
                                          {props.data?.personalInfoDTO
                                            ?.keyPersonalInfoDTO?.udidNumber ??
                                            ""}
                                        </td>
                                      </tr>,
                                    ]
                                  : null}
                              </tbody>
                            </table>
                          </Accordion.Body>
                        </div>
                      )}
                  </Accordion.Item>

                  {/*Additional Personal Info */}

                  <Accordion.Item eventKey="2">
                    {props &&
                      props.data &&
                      props.data.personalInfoDTO &&
                      props.data.personalInfoDTO.additionalPersonalInfoDTO && (
                        <div className={styles.table_content}>
                          <Accordion.Header className="mb-0">
                            <span className={styles.header}>
                              <CsplLabel
                                label={"title.AdditionalPersonalInfo"}
                              ></CsplLabel>
                            </span>
                          </Accordion.Header>
                          <Accordion.Body className={styles.accordion_table}>
                            <table className="table table-striped table-bordered border-white table-responsive">
                              <tbody className={styles.table_alternate_color}>
                                <tr>
                                  <th className={styles.table_header}>
                                    <CsplLabel
                                      label={
                                        "additionalPersonalInfo.occupationType"
                                      }
                                    ></CsplLabel>
                                  </th>
                                  <td>
                                    {
                                      props.data.personalInfoDTO
                                        .additionalPersonalInfoDTO
                                        .occupationType.name
                                    }
                                  </td>
                                </tr>
                                <tr>
                                  <th className={styles.table_header}>
                                    <CsplLabel
                                      label={
                                        "additionalPersonalInfo.educationalQualifications"
                                      }
                                    ></CsplLabel>
                                  </th>
                                  <td>
                                    {
                                      props.data.personalInfoDTO
                                        .additionalPersonalInfoDTO
                                        .educationalQualification.name
                                    }
                                  </td>
                                </tr>
                                <tr>
                                  <th className={styles.table_header}>
                                    <CsplLabel
                                      label={
                                        "additionalPersonalInfo.incomeLevel"
                                      }
                                    ></CsplLabel>
                                  </th>
                                  <td>
                                    {
                                      props.data.personalInfoDTO
                                        .additionalPersonalInfoDTO.incomeLevel
                                        .name
                                    }
                                  </td>
                                </tr>
                                <tr>
                                  <th className={styles.table_header}>
                                    <CsplLabel
                                      label={
                                        "additionalPersonalInfo.areYouaPep"
                                      }
                                    ></CsplLabel>
                                  </th>
                                  <td>
                                    {
                                      props.data.personalInfoDTO
                                        .additionalPersonalInfoDTO
                                        .politicallyExposed
                                    }
                                  </td>
                                </tr>
                                {props.data.personalInfoDTO
                                  .additionalPersonalInfoDTO
                                  .politicallyExposed == OptionsEnum.Yes && (
                                  <tr>
                                    <th className={styles.table_header}>
                                      <CsplLabel
                                        label={
                                          "additionalPersonalInfo.natureOfExposure"
                                        }
                                      ></CsplLabel>
                                    </th>
                                    <td>
                                      {
                                        props.data.personalInfoDTO
                                          .additionalPersonalInfoDTO
                                          .natureOfPoliticalExposued.name
                                      }
                                    </td>
                                  </tr>
                                )}
                                <tr>
                                  <th className={styles.table_header}>
                                    <CsplLabel
                                      label={
                                        "additionalPersonalInfo.areYouRelatedToPep"
                                      }
                                    ></CsplLabel>
                                  </th>
                                  <td>
                                    {
                                      props.data.personalInfoDTO
                                        .additionalPersonalInfoDTO
                                        .relatedPoliticallyExposed
                                    }
                                  </td>
                                </tr>
                                {props.data.personalInfoDTO
                                  .additionalPersonalInfoDTO
                                  .relatedPoliticallyExposed ==
                                  OptionsEnum.Yes && (
                                  <tr>
                                    <th className={styles.table_header}>
                                      <CsplLabel
                                        label={
                                          "additionalPersonalInfo.natureOfExposure"
                                        }
                                      ></CsplLabel>
                                    </th>
                                    <td>
                                      {
                                        props.data.personalInfoDTO
                                          .additionalPersonalInfoDTO
                                          .relatedToPepNatureOfPoliticalExposued
                                          .name
                                      }
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </Accordion.Body>
                        </div>
                      )}
                  </Accordion.Item>

                  {/*Tax Declaration */}

                  <Accordion.Item eventKey="3">
                    {props &&
                      props.data &&
                      props.data.personalInfoDTO &&
                      props.data.personalInfoDTO.taxDeclarationDTO && (
                        <div className={styles.table_content}>
                          <Accordion.Header className="mb-0">
                            <span className={styles.header}>
                              <CsplLabel
                                label={"title.TaxDeclaration"}
                              ></CsplLabel>
                            </span>
                          </Accordion.Header>
                          <Accordion.Body className={styles.accordion_table}>
                            <table className="table table-striped table-bordered border-white table-responsive">
                              <tbody className={styles.table_alternate_color}>
                                <tr>
                                  <th className={styles.table_header}>
                                    <CsplLabel
                                      label={"taxDeclaration.residentialStatus"}
                                    ></CsplLabel>
                                  </th>
                                  <td>
                                    {
                                      props.data.personalInfoDTO
                                        .taxDeclarationDTO.residentOfIndia
                                    }
                                  </td>
                                </tr>
                                {props.data.personalInfoDTO.taxDeclarationDTO
                                  .residentOfIndia ==
                                  OptionsEnum.Non_Resident && (
                                  <tr>
                                    <th className={styles.table_header}>
                                      <CsplLabel
                                        label={"taxDeclaration.passportNumber"}
                                      ></CsplLabel>
                                    </th>
                                    <td>
                                      {
                                        props.data.personalInfoDTO
                                          .taxDeclarationDTO.passportNo
                                      }
                                    </td>
                                  </tr>
                                )}
                                <tr>
                                  <th className={styles.table_header}>
                                    <CsplLabel
                                      label={"taxDeclaration.nationality"}
                                    ></CsplLabel>
                                  </th>
                                  <td>
                                    {
                                      props.data.personalInfoDTO
                                        .taxDeclarationDTO.nationality
                                    }
                                  </td>
                                </tr>
                                <tr>
                                  <th className={styles.table_header}>
                                    <CsplLabel
                                      label={"taxDeclaration.countryOfBirth"}
                                    ></CsplLabel>
                                  </th>
                                  <td>
                                    {
                                      props.data.personalInfoDTO
                                        .taxDeclarationDTO.countryOfBirth
                                    }
                                  </td>
                                </tr>
                                {props.data.personalInfoDTO.taxDeclarationDTO
                                  .stateOfBirthObj && (
                                  <tr>
                                    <th className={styles.table_header}>
                                      <CsplLabel
                                        label={"taxDeclaration.stateOfBirth"}
                                      ></CsplLabel>
                                    </th>
                                    <td>
                                      {
                                        props.data.personalInfoDTO
                                          .taxDeclarationDTO.stateOfBirthObj
                                          .name
                                      }
                                    </td>
                                  </tr>
                                )}
                                {props.data.personalInfoDTO.taxDeclarationDTO
                                  .stateOfBirth && (
                                  <tr>
                                    <th className={styles.table_header}>
                                      <CsplLabel
                                        label={"taxDeclaration.stateOfBirth"}
                                      ></CsplLabel>
                                    </th>
                                    <td>
                                      {
                                        props.data.personalInfoDTO
                                          .taxDeclarationDTO.stateOfBirth
                                      }
                                    </td>
                                  </tr>
                                )}
                                <tr>
                                  <th className={styles.table_header}>
                                    <CsplLabel
                                      label={"taxDeclaration.taxDeclaration"}
                                    ></CsplLabel>
                                  </th>
                                  <td>
                                    {
                                      props.data.personalInfoDTO
                                        .taxDeclarationDTO.taxDeclaration
                                    }
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                            <div
                              className="table-responsive"
                              id={styles.sub_table}
                            >
                              {OptionsEnum.Tax_Resident_Of_India_Only !==
                                props.data.personalInfoDTO.taxDeclarationDTO
                                  .taxDeclaration && (
                                <table
                                  className="table w-100 text-center"
                                  id={styles.sub_table}
                                >
                                  <thead className={styles.sub_table_header}>
                                    <th className="p-2">
                                      <CsplLabel
                                        label={
                                          "taxDeclaration.countriesOfTaxResidency"
                                        }
                                      ></CsplLabel>
                                    </th>
                                    <th className="p-2">
                                      <CsplLabel
                                        label={
                                          "taxDeclaration.taxidentificationNumberOrFunctionalEquivalent"
                                        }
                                      ></CsplLabel>
                                    </th>
                                    <th className="p-2">
                                      <CsplLabel
                                        label={
                                          "taxDeclaration.identificationType"
                                        }
                                      ></CsplLabel>
                                    </th>
                                    <th className="p-2">
                                      <CsplLabel
                                        label={"taxDeclaration.remarks"}
                                      ></CsplLabel>
                                    </th>
                                  </thead>
                                  <tbody className={styles.sub_table_body}>
                                    {props.data.personalInfoDTO.taxDeclarationDTO.taxResidencyCountryDetails.map(
                                      (list) => {
                                        return (
                                          <tr>
                                            <td>
                                              {
                                                list.countryOfTaxResidency.name
                                              }{" "}
                                            </td>
                                            <td>
                                              {" "}
                                              {
                                                list.taxIdentificationNumber
                                              }{" "}
                                            </td>
                                            <td>
                                              {" "}
                                              {list.taxIdentificationType}{" "}
                                            </td>
                                            <td>{list.remarks} </td>
                                          </tr>
                                        );
                                      },
                                    )}
                                  </tbody>
                                </table>
                              )}
                            </div>
                          </Accordion.Body>
                        </div>
                      )}
                  </Accordion.Item>

                  {/*Address Change */}
                  <Accordion.Item eventKey="4">
                    {props &&
                      props.data &&
                      props.data.personalInfoDTO &&
                      props.data.personalInfoDTO.addressProofUploadDTO && (
                        <div className={styles.table_content}>
                          <Accordion.Header className="mb-0">
                            <span className={styles.header}>
                              <CsplLabel
                                label={"title.AddressChange"}
                              ></CsplLabel>
                            </span>
                          </Accordion.Header>
                          <Accordion.Body className={styles.accordion_table}>
                            <table className="table table-striped table-bordered border-white table-responsive">
                              <tbody className={styles.table_alternate_color}>
                                <tr className="bg-primary">
                                  <th
                                    colSpan={2}
                                    className={styles.table_sub_header}
                                  >
                                    <CsplLabel
                                      label={"AddressChange.permanent-Address"}
                                    ></CsplLabel>
                                  </th>
                                </tr>
                                <tr>
                                  <th className={styles.table_header}>
                                    <CsplLabel
                                      label={
                                        "AddressChange.permanentAddressSameAsCkycAadhar"
                                      }
                                    ></CsplLabel>
                                  </th>
                                  <td>
                                    {
                                      props.data.personalInfoDTO
                                        .addressProofUploadDTO
                                        .isPermanentAddressSameAsCKYCAadhaar
                                    }
                                  </td>
                                </tr>
                                {props.data.personalInfoDTO
                                  .addressProofUploadDTO
                                  .isPermanentAddressSameAsCKYCAadhaar ==
                                  OptionsEnum.No && (
                                  <tr>
                                    <th className={styles.table_header}>
                                      <CsplLabel
                                        label={"AddressChange.addressProofType"}
                                      ></CsplLabel>
                                    </th>
                                    <td>
                                      {
                                        props.data.personalInfoDTO
                                          .addressProofUploadDTO
                                          .addressProofType.name
                                      }
                                    </td>
                                  </tr>
                                )}
                                <tr>
                                  <th className={styles.table_header}>
                                    <CsplLabel
                                      label={"AddressChange.addressLine1"}
                                    ></CsplLabel>
                                  </th>
                                  <td>
                                    {
                                      props.data.personalInfoDTO
                                        .addressProofUploadDTO.addressLine1
                                    }
                                  </td>
                                </tr>
                                <tr>
                                  <th className={styles.table_header}>
                                    <CsplLabel
                                      label={"AddressChange.addressLine2"}
                                    ></CsplLabel>
                                  </th>
                                  <td>
                                    {
                                      props.data.personalInfoDTO
                                        .addressProofUploadDTO.addressLine2
                                    }
                                  </td>
                                </tr>
                                <tr>
                                  <th className={styles.table_header}>
                                    <CsplLabel
                                      label={"AddressChange.addressLine3"}
                                    ></CsplLabel>
                                  </th>
                                  <td>
                                    {
                                      props.data.personalInfoDTO
                                        .addressProofUploadDTO.addressLine3
                                    }
                                  </td>
                                </tr>
                                <tr>
                                  <th className={styles.table_header}>
                                    <CsplLabel
                                      label={"AddressChange.city"}
                                    ></CsplLabel>
                                  </th>
                                  <td>
                                    {
                                      props.data.personalInfoDTO
                                        .addressProofUploadDTO.city
                                    }
                                  </td>
                                </tr>
                                <tr>
                                  <th className={styles.table_header}>
                                    <CsplLabel
                                      label={"AddressChange.country"}
                                    ></CsplLabel>
                                  </th>
                                  <td>
                                    {
                                      props.data.personalInfoDTO
                                        .addressProofUploadDTO.country.name
                                    }
                                  </td>
                                </tr>
                                <tr>
                                  <th className={styles.table_header}>
                                    <CsplLabel
                                      label={"AddressChange.state"}
                                    ></CsplLabel>
                                  </th>
                                  <td>
                                    {
                                      props.data.personalInfoDTO
                                        .addressProofUploadDTO.state.name
                                    }
                                  </td>
                                </tr>
                                <tr>
                                  <th className={styles.table_header}>
                                    <CsplLabel
                                      label={"AddressChange.pinCode"}
                                    ></CsplLabel>
                                  </th>
                                  <td>
                                    {
                                      props.data.personalInfoDTO
                                        .addressProofUploadDTO.pinCode
                                    }
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </Accordion.Body>
                        </div>
                      )}
                  </Accordion.Item>
                </Accordion>
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </div>
      </Accordion>
    </>
  );
}

export default PersonalInfoView;
